export const DYNAMIC_INFO_PREDICTION_TIME_PARAM = 'time';
